import datapoints from '../datapoints';
import { PerformanceDatapoint } from 'owa-analytics';
import { loadTailoredXpData, mailStore } from 'owa-mail-store';
import { createCalendarPerfDatapoint } from 'owa-shared-analytics';
import { action, select } from 'satcheljs/lib/legacy';
export default action('getItemTailoredXpData')(select({
    items: function () { return mailStore.items; },
})(function getItemTailoredXpData(newItem, state) {
    var newItemId = newItem.ItemId.Id;
    var newTxpEntitiesChangeNumber = newItem.TailoredXpEntitiesChangeNumber;
    if (newTxpEntitiesChangeNumber && newTxpEntitiesChangeNumber > 0) {
        var oldItem = state.items.get(newItemId);
        // oldItem refers to an item with the same ID (read: the same item) that already lives in the client's mailStore.
        // If the newItem has a TxPChangeNumber, the oldItem should too.
        // This portion of the if statement is meant to capture updates to an existing item.
        // But intermittently we were seeing old items with the change number undefined which was causing us to not load the txp cards.
        // If we do see an undefined value we should change it to 0 otherwise oldItem.TailoredXpEntitiesChangeNumber < newItem.TailoredXpEntitiesChangeNumber will fail.
        var oldTailoredXpEntitiesChangeNumber = oldItem && oldItem.TailoredXpEntitiesChangeNumber
            ? oldItem.TailoredXpEntitiesChangeNumber
            : 0;
        if ((!oldItem || oldTailoredXpEntitiesChangeNumber < newTxpEntitiesChangeNumber) &&
            !newItem.TailoredXpEntities) {
            // If the old item doesn't exist, or its change number is different and the new item doesn't already have the TxP data, load it.
            var datapoint_1 = new PerformanceDatapoint(datapoints.RPPerfGetTailoredXpData.datapoint.name);
            var TxpDatapoint_1 = createCalendarPerfDatapoint('TXPLoadMail');
            loadTailoredXpData(newItemId)
                .then(action('updateTailoredXpEntities')(function updateTailoredXpEntities(tailoredXpData) {
                var itemInCache = state.items.get(newItemId);
                if (itemInCache) {
                    itemInCache.TailoredXpEntities = tailoredXpData.TailoredXpEntities;
                    itemInCache.TailoredXpCalendarEventIds =
                        tailoredXpData.TailoredXpCalendarEventIds;
                    itemInCache.TailoredXpEntitiesStatus =
                        tailoredXpData.TailoredXpEntitiesStatus;
                    itemInCache.EntityNamesMap = tailoredXpData.EntityNamesMap;
                }
                datapoint_1.end();
                TxpDatapoint_1.end();
            }))
                .catch(function (error) {
                datapoint_1.endWithError("ServerError" /* ServerError */, error);
                TxpDatapoint_1.endWithError("ServerError" /* ServerError */, error);
            });
        }
    }
}));
//# sourceMappingURL=getItemTailoredXpData.js.map